import { useEffect } from 'react'

import Handler3DSecure from 'hooks/handler3DSecure'

import { COMPONENT_EXTENDER } from 'extender'

const AccountPage = COMPONENT_EXTENDER('pages/AccountPage')

const Handle3DSecurePage = () => {
    const { start3dSecure } = Handler3DSecure()

    useEffect(() => {
        start3dSecure()
    }, [])

    return <AccountPage />
}

export default Handle3DSecurePage
